export const USER_PRESCRIPTION = 'USER_PRESCRIPTION';

export const USE_MY_FRAME_PRESCRIPTION = 'USE_MY_FRAME_PRESCRIPTION';
